export { default } from "./ServiceDetail";

export const services = [
  {
    id: 16,
    icon: "./odniSTR.svg",
    title: "Одностраничный сайт",
    price: "от 100 000 ₽",
    category: "landing",
    description:
      "Идеально подойдёт для презентации продукта, услуги или сбора заявок.",
    info: [
      "Современный дизайн, сфокусированный на побуждении к целевому действию (заявка, звонок).",
      "Полная адаптивность для корректного отображения на мобильных устройствах.",
      "Высокая скорость загрузки и оптимизация производительности.",
      "Интеграция с системами аналитики и формами для сбора заявок.",
      "По желанию: подключение онлайн-чата, CRM-системы и Telegram-уведомлений.",
    ],
  },

  {
    id: 3,
    icon: "/y2.svg",
    title: "Корпоративные сайты",
    price: "от 250 000 ₽",
    category: "corporate",
    description:
      "Решение для компаний с широкой структурой, большим числом услуг, командой, блогом и пр.",
    info: [
      "Гибкая архитектура сайта с разделами под каждое направление",
      "Презентация команды, документов, партнёров, вакансий",
      "Интеграция с внутренними или внешними сервисами",
      "Поддержка мультиязычности, личного кабинета, блог-раздела",
      "Безопасность, масштабируемость, административная панель",
    ],
  },
  {
    id: 4,
    icon: "/y4.svg",
    title: "Интернет-магазины",
    price: "от 400 000 ₽",
    category: "ecommerce",
    description:
      "Полнофункциональные e-commerce решения с интеграцией платежных систем и управления товарами.",
    info: [
      "Каталог товаров с фильтрами и поиском",
      "Корзина и оформление заказов",
      "Интеграция с платежными системами",
      "Панель управления заказами и товарами",
      "Личный кабинет покупателя",
    ],
  },
  {
    id: 5,
    icon: "/y5.svg",
    title: "Мобильные приложения",
    price: "от 700 000 ₽",
    category: "mobile",
    description:
      "Pазрабатываем нативные и кроссплатформенные приложения под Android и iOS: от MVP до масштабируемых решений. Продумываем логику, дизайн и архитектуру с фокусом на пользовательский опыт и цели бизнеса.",
    info: [
      "Кроссплатформенная разработка",
      "Интеграция с API и сервисами",
      "Тестирование на реальных устройствах",
      "Публикация в Google Play Store",
      "Техническая документация",
    ],
  },
  {
    id: 6,
    icon: "/y6.svg",
    title: "Веб-приложения",
    price: "от 1 000 000 ₽",
    category: "webapp",
    description:
      "Создание сложных веб-приложений (SPA/PWA) с использованием React, Vue.js или Angular.",
    info: [
      "Архитектура SPA/PWA",
      "Backend-интеграции",
      "Административная панель",
      "Система аутентификации",
      "Масштабируемая архитектура",
    ],
  },
  {
    id: 7,
    icon: "/y7.svg",
    title: "UI/UX Дизайн",
    price: "от 170 000 ₽",
    category: "uidesign",
    description:
      "Разработка пользовательских интерфейсов и прототипирование с учетом юзабилити.",
    info: [
      "Исследование целевой аудитории",
      "Создание wireframes и прототипов",
      "UI дизайн всех экранов",
      "Дизайн-система и гайдлайны",
      "Подготовка для разработчиков",
    ],
  },
  {
    id: 8,
    icon: "/y8.svg",
    title: "Редизайн сайтов",
    price: "от 200 000 ₽",
    category: "redesign",
    description:
      "Современное обновление устаревших сайтов с улучшением UX и адаптацией под мобильные устройства.",
    info: [
      "Аудит текущего сайта",
      "Разработка новой концепции",
      "Улучшение пользовательского опыта",
      "Адаптация под мобильные устройства",
      "Перенос контента",
    ],
  },
  {
    id: 10,
    icon: "/icons8.svg",
    title: "Техническая поддержка",
    price: "от 50 000 ₽/мес",
    category: "support",
    description:
      "Постоянное сопровождение сайтов: обновления, доработки, исправление ошибок и консультации.",
    info: [
      "Регулярное обновление и мониторинг",
      "Исправление ошибок и багов",
      "Технические консультации",
      "Резервное копирование",
      "Поддержка 24/7",
    ],
  },
  {
    id: 14,
    icon: "/y14.svg",
    title: "Автоматизация бизнеса",
    price: "от 400 000 ₽",
    category: "automation",
    description:
      "Создание внутренних систем автоматизации бизнес-процессов и CRM-решений.",
    info: [
      "Анализ бизнес-процессов",
      "Разработка CRM-системы",
      "Интеграция с внешними сервисами",
      "Автоматизация отчетности",
      "Обучение персонала",
    ],
  },
  {
    id: 15,
    icon: "/y15.svg",
    title: "Хостинг и DevOps",
    price: "от 30 000 ₽",
    category: "devops",
    description:
      "Настройка серверов, развертывание проектов и обеспечение бесперебойной работы сайтов.",
    info: [
      "Настройка серверного окружения",
      "Развертывание приложений",
      "Мониторинг и аналитика",
      "Система резервного копирования",
      "Оптимизация производительности",
    ],
  },
];

export const categoryNames = {
  landing: "Лендинги",
  markup: "Верстка сайтов",
  corporate: "Корпоративные сайты",
  ecommerce: "Интернет-магазины",
  mobile: "Мобильные приложения",
  webapp: "Веб-приложения",
  uidesign: "UI/UX Дизайн",
  redesign: "Редизайн сайтов",
  support: "Техническая поддержка",
  automation: "Автоматизация бизнеса",
  devops: "Хостинг и DevOps",
  all: "Все наши услуги",
};
